import { GET_PUBLIC_API_KEYS, USER_LOADED, AUTH_ERROR, UPDATE_USER, LOGIN_SUCCESS, LOGIN_FAIL, UPDATE_USER_FAIL, LOGOUT } from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  publicApiKeys: false,
  isAuthenticated: false,
  loading: true,
  user: null,
  error: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PUBLIC_API_KEYS:
      return {
        ...state,
        publicApiKeys: payload,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: payload,
      };
    case UPDATE_USER_FAIL:
      return {
        ...state,
        user: state.user,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload,
      };

    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.token);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };

    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    default:
      return state;
  }
}
